'use client';
import Script from 'next/script';
import { ELEVAR_CONFIG_ID } from '@/lib/elevar/constants';

export default function ElevarScript() {
  return (
    <Script
      id="elevar-gtm-script"
      type="module"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          let __elevarResolve;
          window.__elevarReady = new Promise(r => { __elevarResolve = r; });
          (async () => {
            const settings = {};
            let config, handler;
            try {
              config = (await import("https://shopify-gtm-suite.getelevar.com/configs/${ELEVAR_CONFIG_ID}/config.js")).default;
              const scriptUrl = settings.proxyPath
                ? settings.proxyPath + config.script_src_custom_pages_proxied
                : config.script_src_custom_pages;
              if (scriptUrl) ({ handler } = await import(scriptUrl));
            } catch (err) {
              // BL-978: mostly tracker blockers, which RUM shouldn't count as errors.
              console.warn('Elevar failed to load.', err);
            }
            try {
              await handler?.(config, settings);
            } catch (err) {
              console.error('Elevar GTM Error.', err);
            } finally {
              __elevarResolve();
            }
          })();
        `,
      }}
      onLoad={() => {
        window?.ElevarInvalidateContext?.();
      }}
    />
  );
}
